// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1gE-p","consentsList":"PatientConsents_consentsList__1S_f-","consentsListEmpty":"PatientConsents_consentsListEmpty__13qpB"};